export function openPage(pageUrl) {
    window.location.assign(pageUrl);
}

export function openNewPage(pageUrl) {
    window.open(pageUrl);
}